const EMAIL_DOMAIN_TO_LOGIN_LINK = {
  gmail: 'https://mail.google.com/#search/from%3Agroover+in%3Aall',
  googlemail: 'https://mail.google.com/#search/from%3Agroover+in%3Aall',
  yahoo: 'https://login.yahoo.com',
  hotmail: 'https://login.live.com/login.srf',
  outlook: 'https://login.live.com/login.srf',
  orange: 'https://login.orange.fr/',
  wanadoo: 'https://login.orange.fr/',
} as const
export type AvailableService = keyof typeof EMAIL_DOMAIN_TO_LOGIN_LINK

type EmailProviderLoginLink =
  (typeof EMAIL_DOMAIN_TO_LOGIN_LINK)[AvailableService]

export function getLoginLinkFromEmail(
  emailAddress: string,
): false | EmailProviderLoginLink {
  const hasEmail = typeof emailAddress === 'string' && emailAddress.length
  if (!hasEmail) return false

  const emailRegexp = /\b.*@([A-Za-z0-9.-]+\.[A-Za-z]{2,4})\b/
  const emailMatches = emailAddress.match(emailRegexp)
  const domainName = emailMatches ? emailMatches[1] : undefined
  const host = (domainName as string).split('.')[0] as AvailableService

  return EMAIL_DOMAIN_TO_LOGIN_LINK[host as AvailableService] ?? false
}
